<div class="files-grid">
  <div class="file-container" *ngFor="let file of internalFiles; let i = index">
    <button *ngIf="canEdit" type="button" class="delete-file-btn" [attr.aria-label]="'request_v2.info.delete_file' | translate" (click)="removeFile(i); $event.stopPropagation()">
      <mat-icon>close</mat-icon>
    </button>

    <ng-container *ngIf="isImage(file)">
      <button type="button" class="file-preview" [attr.aria-label]="('request_v2.info.open_file' | translate) + ' ' + getFileName(file)" (click)="downloadFile(file)">
        <img [src]="file.url" [alt]="getFileName(file)">
      </button>
    </ng-container>

    <ng-container *ngIf="!isImage(file)">
      <button type="button" class="file-preview document-icon" [attr.aria-label]="('request_v2.info.open_file' | translate) + ' ' + getFileName(file)" (click)="downloadFile(file)">
        <img *ngIf="isDocumentPdf(file)" src="assets/images/pdf-file.svg" alt="PDF File">
        <img *ngIf="isDocumentWord(file)" src="assets/images/word-file.svg" alt="Word File">
        <img *ngIf="isDocumentExcel(file)" src="assets/images/sheets-file.svg" alt="Excel File">
        <mat-icon *ngIf="!isDocumentPdf(file) && !isDocumentWord(file) && !isDocumentExcel(file)">insert_drive_file</mat-icon>
      </button>
    </ng-container>

    <div class="file-name">{{ getFileName(file) }}</div>
  </div>

  <!-- Upload in progress placeholder -->
  <div class="file-container" *ngIf="isUploading">
    <div class="file-uploading"></div>
  </div>

  <div class="file-container" *ngIf="canEdit && !isUploading">
    <div class="add-file-btn"
         [class.drag-over]="isDragOver"
         [class.disabled]="isDeleting"
         (click)="!isDeleting && addFile()"
         (drop)="!isDeleting && onDrop($event)">
      <ng-container *ngIf="!isDragOver">
        <mat-icon>add</mat-icon>
      </ng-container>
      <ng-container *ngIf="isDragOver">
        <mat-icon class="upload-icon">upload</mat-icon>
        <span class="upload-label">{{ 'request_v2.info.upload' | translate }}</span>
      </ng-container>
    </div>
  </div>
</div>

<input
  *ngIf="canEdit"
  type="file"
  #fileInput
  multiple
  style="display: none"
  (change)="onFileSelected($event)"
  accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx">
